module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-admin-footer"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "content-admin-footer-inner"
  }, [_vm._v("\r\n                © " + _vm._s(_vm.this_year) + " cityneeds. All rights reserved.\r\n            ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6827bbfe"}!./src/components/Dashboard-Footer/template.html
// module id = 300
// module chunks = 0